import api from '@api'
import { generateId } from '@utils/id'
import {
  getRootTranslator,
  getRootPluaralTranslator,
} from '@utils/get-module-translator'
import { buildFlatQualificationStructure } from '@data/qualification'
import { transformAssetForList } from '@data/asset'
import {
  transformSoftwareMeter,
  transformSoftwareMeterForServer,
} from '@data/software-meter'

import { transformDiscoveryAgents } from '@data/discovery-agents'

const __rootT = getRootTranslator()
const __rootTc = getRootPluaralTranslator()

export function agentSearchByQaul(searchCriteria, limit, offset, sortedColumn) {
  const qualDetails = [...((searchCriteria || {}).quals || [])]
  return api
    .post(
      `/asset_software/swMeter/search/byqual`,
      {
        qualDetails: qualDetails.length
          ? buildFlatQualificationStructure(qualDetails)
          : undefined,
      },
      {
        params: {
          offset: offset || 0,
          size: limit === undefined ? 1000 : limit,
          ...(sortedColumn ? { sort_by: sortedColumn } : {}),
        },
        notify: false,
      }
    )
    .then((data) => {
      return {
        items: (data.objectList || []).map(transformAssetForList) || [],
        total: data.totalCount,
      }
    })
}
export function getSoftwareMeterAgentsApi(
  searchCriteria,
  assetId,
  limit,
  offset
) {
  const qualDetails = [...((searchCriteria || {}).quals || [])]
  return api
    .post(
      `/asset_software/${assetId}/swMeter/getAgents`,
      {
        qualDetails: qualDetails.length
          ? buildFlatQualificationStructure(qualDetails)
          : undefined,
      },
      {
        params: {
          offset: offset || 0,
          size: limit === undefined ? 1000 : limit,
        },
        notify: false,
      }
    )
    .then((data) => {
      return {
        items: (data.objectList || []).map(transformDiscoveryAgents) || [],
        total: data.totalCount,
        usageCount: data.usageCount,
        usageDuration: data.usageDuration,
        lastUsedTime: data.lastUsedTime,
      }
    })
}
export function getSoftwareMeterApi(assetId) {
  return api.get(`/asset_software/${assetId}/swMeter`, {
    notify: false,
  })
}

export function createSoftwareMeterApi(assetId, data) {
  const updateData = transformSoftwareMeterForServer(data)
  return api
    .post(`/asset_software/${assetId}/swMeter`, updateData, {
      message: __rootT('configured_successfully', {
        resource: __rootTc('software_meter'),
      }),
    })
    .then(transformSoftwareMeter)
}

export function removeSoftwareMeterApi(assetId) {
  return api.delete(`/asset_software/${assetId}/swMeter`, {
    message: __rootT('removed_successfully', {
      resource: __rootTc('software_meter'),
    }),
  })
}

export function updateSoftwareMeterApi(assetId, data) {
  const updateData = transformSoftwareMeterForServer(data)
  return api
    .patch(`/asset_software/${assetId}/swMeter`, updateData, {
      message: __rootT('updated_successfully', {
        resource: __rootTc('software_meter'),
      }),
    })
    .then(transformSoftwareMeter)
}

export function toggleSoftwareMeterApi(assetId, data) {
  return api
    .patch(`/asset_software/${assetId}/swMeter`, data, {
      message: __rootT('updated_successfully', {
        resource: __rootTc('software_meter'),
      }),
    })
    .then(transformSoftwareMeter)
}

export function getSoftwareUsageApi(assetId, agentId, data) {
  return api
    .post(
      `/swUsage/asset_software/${assetId}/agent/${agentId}`,
      {},
      {
        params: {
          startDate: data.startDate,
          endDate: data.endDate,
        },
        notify: false,
      }
    )
    .then((data) => {
      return {
        items: (data.objectList || []).map((d) => ({ ...d, id: generateId() })),
        usageDuration: data.usageDuration,
      }
    })
}

export function resetSoftwareMeterApi(assetId) {
  return api
    .post(
      `/asset_software/${assetId}/swMeter/reset`,
      {},
      {
        message: __rootT('reset_successfully', {
          resource: __rootTc('software_meter'),
        }),
      }
    )
    .then(transformSoftwareMeter)
}

export function removeSoftwareMeterAgentApi(assetId, agentId) {
  return api.delete(`/asset_software/${assetId}/swMeter/${agentId}`, {
    message: __rootT('removed_successfully', {
      resource: __rootTc('agent'),
    }),
  })
}

export function bulkDeleteSoftwareMeterAgentApi(assetId, agentIds) {
  return api.delete(`/asset_software/${assetId}/swMeter/bulk/delete`, {
    data: { objectIds: agentIds },
    message: __rootT('removed_successfully', {
      resource: __rootTc('agent'),
    }),
  })
}
